<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-account"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <v-col>
            <div class="text-h2 font-weight-light">
              {{ $t('actions') }}
            </div>
          </v-col>
        </template>
        <v-row>
          <v-col
            cols="4"
          >
            <v-card class="pa-2 mt-0">
              <div class="text-h2 text-center">
                Trackingrapport
              </div>

              <v-form>
                <v-text-field
                  v-model="trackingReportString"
                  label="Indtast link fra CoolDesk indeholdende filtrering"
                  onfocus="this.select();"
                  onmouseup="return false;"
                />
                <v-row>
                  <v-col
                    cols="6"
                    class="text-center"
                  >
                    <v-btn
                      color="orange"
                      :disabled="!trackingReportString"
                      :loading="loadingTracking"
                      @click="downloadTrackingReport"
                    >
                      {{ $t('download') }}

                      <template v-slot:loader>
                        <v-progress-circular
                          indeterminate
                          :size="16"
                          :width="2"
                          style="margin-right: 10px"
                        />
                        <span>{{ (downloadProgress/1000000).toFixed(2) }}MB</span>
                      </template>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="6"
                    class="text-center"
                  >
                    <v-btn
                      color="green"
                      :disabled="!trackingReportString"
                      :loading="loadingTracking"
                      @click="generateTrackingReport"
                    >
                      {{ $t('generate') }} trackingrapport
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>

          <v-col
            cols="4"
          >
            <v-card class="pa-2 mt-0">
              <v-form>
                <div class="text-h2 text-center">
                  {{ $t('reset') + " "+ $t('password') }}
                </div>
                <v-row>
                  <v-col
                    cols="12"
                    class="text-center"
                  >
                    <v-btn
                      color="primary"
                      @click="resetPassword"
                    >
                      {{ $t('reset') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
          <v-col
            cols="4"
          >
            <v-card class="pa-2 mt-0">
              <v-form>
                <div class="text-h2 text-center">
                  {{ $t('delete') + " "+ $t('user') }}
                </div>
                <v-row>
                  <v-col
                    cols="12"
                    class="text-center"
                  >
                    <v-btn
                      color="primary"
                      @click="deleteUser"
                    >
                      {{ $t('delete') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
          <v-col
            cols="4"
          >
            <v-card class="pa-2 mt-0">
              <v-form>
                <div class="text-h2 text-center">
                  {{ $t('update') + " "+ $t('pincode') }}
                </div>
                <v-row>
                  <v-col
                    cols="12"
                    class="text-center"
                  >
                  <v-text-field
                  v-model="pincode"
                  :label="$t('pincode') + ' (max 4 tegn)'"
                  onfocus="this.select();"
                  onmouseup="return false;"
                />
                    <v-btn
                      color="primary"
                      @click="updatePincode"
                    >
                      {{ $t('update') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>
  </v-row>
</template>
<script>
  import localStorage from '../../../../plugins/localstorage'
  import Auth from '../../../../mixins/Auth'
  export default {

    mixins: [Auth],
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        name: 'actions',
        trackingReportString: '',
        loadingTracking: false,
        downloadProgress: 0,
        pincode: ''
      }
    },
    mounted: function () {
      this.trackingReportString = localStorage.get(`${this.$route.params.id}_tracking_report_url`)
    },
    methods: {
      resetPassword: function () {
        const confirm = prompt('Skriv "nulstil" for at bekræfte')
        if (confirm === 'nulstil') {
          this.$post(`customers/${this.$route.params.id}/reset-password`)
            .then(res => {
              this.$toast(`${res.data.message}`, { color: 'green' })
            })
        } else {
          this.$toast('Reset afbrudt', { color: 'red' })
        }
      },
      updatePincode: function () {
        const confirm = prompt('Skriv "opdater" for at bekræfte')
        if (confirm === 'opdater') {
          this.$post(`customers/${this.$route.params.id}/reset-pin`, {new_pin: this.pincode})
            .then(res => {
              this.$toast(`${res.data.message}`, { color: 'green' })
            })
        } else {
          this.$toast('Reset afbrudt', { color: 'red' })
        }
      },
      deleteUser: function () {
        const confirm = prompt('Skriv "slet" for at bekræfte')
        if (confirm === 'slet') {
          this.$post(`customers/${this.$route.params.id}/delete`)
            .then(res => {
              this.$toast(`${res}`, { color: 'green' })
            })
        } else {
          this.$toast('Sletning afbrudt', { color: 'red' })
        }
      },
      downloadTrackingReport: function () {
        localStorage.set(`${this.$route.params.id}_tracking_report_url`, this.trackingReportString)
        this.loadingTracking = true
        this.$post(`customers/${this.$route.params.id}/tracking-report/download`, { filter_url: this.trackingReportString }, {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            this.downloadProgress = progressEvent.loaded
          },
        })
          .then(response => {
            const contentDisposition = response.headers['content-disposition']
            if (contentDisposition) {
              let fileName = contentDisposition.split('filename=')[1]
              fileName = fileName.replace(/["']/g, '')

              const link = document.createElement('a')

              const binaryData = []
              binaryData.push(response.data)

              link.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'text/csv' }))
              link.download = fileName
              link.click()
            }
          })
          .finally(() => {
            this.loadingTracking = false
            this.downloadProgress = 0
          })
      },
      generateTrackingReport: function () {
        localStorage.set(`${this.$route.params.id}_tracking_report_url`, this.trackingReportString)
        this.loadingTracking = true
        this.$post(`customers/${this.$route.params.id}/tracking-report/generate`, { filter_url: this.trackingReportString })
          .then(res => {
            this.$toast(`${res.data.message}`, { color: 'green' })
          })
          .finally(() => {
            this.loadingTracking = false
          })
      },
    },
  }
</script>
